/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CRSFDataleakRiskSummary } from './CRSFDataleakRiskSummary';
import {
    CRSFDataleakRiskSummaryFromJSON,
    CRSFDataleakRiskSummaryFromJSONTyped,
    CRSFDataleakRiskSummaryToJSON,
} from './CRSFDataleakRiskSummary';
import type { CRSFDataleaksRiskSummaryObject } from './CRSFDataleaksRiskSummaryObject';
import {
    CRSFDataleaksRiskSummaryObjectFromJSON,
    CRSFDataleaksRiskSummaryObjectFromJSONTyped,
    CRSFDataleaksRiskSummaryObjectToJSON,
} from './CRSFDataleaksRiskSummaryObject';

/**
 * 
 * @export
 * @interface RiskSummary
 */
export interface RiskSummary {
    /**
     * 
     * @type {CRSFDataleaksRiskSummaryObject}
     * @memberof RiskSummary
     */
    all_time: CRSFDataleaksRiskSummaryObject;
    /**
     * 
     * @type {string}
     * @memberof RiskSummary
     */
    domain: string;
    /**
     * 
     * @type {CRSFDataleaksRiskSummaryObject}
     * @memberof RiskSummary
     */
    previous_12_months: CRSFDataleaksRiskSummaryObject;
    /**
     * 
     * @type {CRSFDataleaksRiskSummaryObject}
     * @memberof RiskSummary
     */
    previous_1_month?: CRSFDataleaksRiskSummaryObject;
    /**
     * 
     * @type {CRSFDataleaksRiskSummaryObject}
     * @memberof RiskSummary
     */
    previous_6_months: CRSFDataleaksRiskSummaryObject;
}

/**
 * Check if a given object implements the RiskSummary interface.
 */
export function instanceOfRiskSummary(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "all_time" in value;
    isInstance = isInstance && "domain" in value;
    isInstance = isInstance && "previous_12_months" in value;
    isInstance = isInstance && "previous_6_months" in value;

    return isInstance;
}

export function RiskSummaryFromJSON(json: any): RiskSummary {
    return RiskSummaryFromJSONTyped(json, false);
}

export function RiskSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): RiskSummary {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'all_time': CRSFDataleaksRiskSummaryObjectFromJSON(json['all_time']),
        'domain': json['domain'],
        'previous_12_months': CRSFDataleaksRiskSummaryObjectFromJSON(json['previous_12_months']),
        'previous_1_month': !exists(json, 'previous_1_month') ? undefined : CRSFDataleaksRiskSummaryObjectFromJSON(json['previous_1_month']),
        'previous_6_months': CRSFDataleaksRiskSummaryObjectFromJSON(json['previous_6_months']),
    };
}

export function RiskSummaryToJSON(value?: RiskSummary | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'all_time': CRSFDataleaksRiskSummaryObjectToJSON(value.all_time),
        'domain': value.domain,
        'previous_12_months': CRSFDataleaksRiskSummaryObjectToJSON(value.previous_12_months),
        'previous_1_month': CRSFDataleaksRiskSummaryObjectToJSON(value.previous_1_month),
        'previous_6_months': CRSFDataleaksRiskSummaryObjectToJSON(value.previous_6_months),
    };
}

